export default __webpack_public_path__ + "static/district-ae212b46f103ef8823301d705bc30b0d.png";